import React, { Component } from 'react'
import { CloseIcon } from './chat-button-closeicon'
import UserInfo from "../../services/user-info";
import { connect } from "react-redux";
import { closeChat, reapperChat } from '../../actions/app';


// props do componente
// height - para o ícone
// width - para o ícone
// closeButtonSide

class CloseButton extends Component {
  userInfo = UserInfo.getInfo();

  constructor(props) {
    super(props)
    this.state = ({
      hover: false,
      showButton: true,
      timeoutId: null
    })
  }

  handleMouseEnter = (e) => {
    e.stopPropagation();
    this.setState({ hover: true })
  }

  handleMouseLeave = (e) => {
    e.stopPropagation();
    this.setState({ hover: false })
  }

  componentWillUnmount() {
    const { timeoutId } = this.state;
    if (timeoutId) {
      clearTimeout(timeoutId);
    }
  }

  handleClick = () => {
    const { close, clearIntervals, reapper, config } = this.props;
    const reappearTimeInMilliseconds = config.reappearWebChannel * 1000
    close();
    clearIntervals();

    if (reappearTimeInMilliseconds > 0) {
      const timeoutId = setTimeout(() => {
        reapper();
      }, reappearTimeInMilliseconds);
      this.setState({ timeoutId });
    }
  };

  getCloseButtonStyle = () => {
    const platform = this.userInfo.isMobile ? 'mobile' : 'desktop';
    const configPlatform = this.props.config[platform];
    const closeButtonStyle = {
      font: 'inherit',
      backgroundColor: 'transparent',
      border: 'none',
      borderRadius: '50%',
      padding: 0,
      margin: 0,
      marginRight: `${configPlatform.buttonMarginRight}px`,
      marginLeft: `${configPlatform.buttonMarginLeft}px`,
      marginBottom: `${configPlatform.buttonMarginBottom}px`,
      lineHeight: `${configPlatform.buttonHeight}px`,
      height: 'auto',
      width: 'auto',
      outline: 'none',
      cursor: 'pointer',
      position: 'absolute',
      bottom: '-.4rem',
      ...this.props.closeButtonSide,
      pointerEvents: 'auto',
      display: !this.props.showButton && !this.userInfo.isMobile ? 'none' : 'initial'
    }
    return closeButtonStyle
  }
  render() {
    const { hover } = this.state;
    const iconColor = hover ? '#0F2454' : '#091633';

    return (
      <button title="fechar Assistente Virtual"
        style={this.getCloseButtonStyle()}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
        onClick={this.handleClick}
      >
        <CloseIcon width={this.props.width} height={this.props.height} iconColor={iconColor} />
      </button>
    );
  }
}


const mapStateToProps = (state) => ({
  config: state.config,
});

const mapDispatchToProps = (dispatch) => ({
  close: () => dispatch(closeChat()),
  reapper: () => dispatch(reapperChat())
});

export default connect(mapStateToProps, mapDispatchToProps)(CloseButton);